import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <footer className="px-4 md:px-6 pb-8 pt-4">
      <div className="max-w-7xl mx-auto bg-primary-700 rounded-3xl px-8 md:px-14 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h4 className="text-2xl font-light text-white mb-4">
              {t("footer.stayUpdated")}
            </h4>
            <p className="text-sm text-white/60 mb-6 leading-relaxed max-w-sm">
              Receba as últimas atualizações de sellers e novos guias diretamente no seu e-mail.
            </p>
            <form className="flex flex-col sm:flex-row gap-3" data-readdy-form="newsletter-footer" action="https://readdy.ai/api/form/d8pb537ij7vns5otj7q0" method="POST">
              <input
                type="email"
                name="email"
                placeholder={t("footer.emailPlaceholder")}
                className="flex-1 bg-transparent border-b border-white/20 text-white text-sm py-2 px-0 outline-none placeholder:text-white/40 focus:border-white/60 transition-colors"
                required
              />
              <button
                type="submit"
                className="bg-white text-foreground-950 px-6 py-2 rounded-full text-sm hover:bg-white/90 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {t("footer.subscribe")}
              </button>
            </form>
          </div>

          <div className="md:col-span-2">
            <h5 className="text-xs text-white/40 uppercase tracking-wider mb-4">
              {t("footer.navigation")}
            </h5>
            <div className="flex flex-col gap-3">
              <Link
                to="/"
                className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
              >
                {t("nav.home")}
              </Link>
              {isHome ? (
                <a
                  href="#categorias"
                  className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
                >
                  {t("nav.categories")}
                </a>
              ) : (
                <Link
                  to="/"
                  className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
                >
                  {t("nav.categories")}
                </Link>
              )}
              {isHome ? (
                <a
                  href="#artigos"
                  className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
                >
                  {t("nav.articles")}
                </a>
              ) : (
                <Link
                  to="/"
                  className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
                >
                  {t("nav.articles")}
                </Link>
              )}
              <Link
                to="/artigo/cssbuy-spreadsheet-guia-completo"
                className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
              >
                Guia Completo
              </Link>
            </div>
          </div>

          <div className="md:col-span-2">
            <h5 className="text-xs text-white/40 uppercase tracking-wider mb-4">
              Categorias
            </h5>
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com/category-911-Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
              >
                Shoes
              </a>
              <a
                href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
              >
                Hoodies
              </a>
              <a
                href="https://kaspreadsheet.com/category-913-T-Shirts.html"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
              >
                T-Shirts
              </a>
              <a
                href="https://kaspreadsheet.com/category-914-Jackets.html"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
              >
                Jackets
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h5 className="text-xs text-white/40 uppercase tracking-wider mb-4">
              {t("footer.contact")}
            </h5>
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-white/70 hover:text-white transition-colors duration-200 underline"
              >
                kaspreadsheet.com
              </a>
              <p className="text-sm text-white/50">
                CSSBuy Spreadsheet Team
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-white/50 hover:text-white/80 transition-colors duration-200 underline"
            >
              Instagram
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-white/50 hover:text-white/80 transition-colors duration-200 underline"
            >
              Twitter
            </a>
          </div>
          <p className="text-sm text-white/40">
            {t("footer.rights")}
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="text-sm text-white/50 hover:text-white/80 transition-colors duration-200 underline"
            >
              {t("footer.privacy")}
            </Link>
            <Link
              to="/"
              className="text-sm text-white/50 hover:text-white/80 transition-colors duration-200 underline"
            >
              {t("footer.terms")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}